// extracted by mini-css-extract-plugin
export default {"root":"oC7Y0QzqeMC3Hn4bCaxA","success":"kuvoVh2iSKC80F_e05KG","error":"qmHgI5JtYhVvXiYhAB8a","placeHolderShimmer":"DcNaTeOVURO3d9_VQkn7"};